export const aloneApi = {
  getSessionId: { // 获取session-id
      method: 'get',
      api: 'admin/common/getSessionId'
  },
  changepwd: { // 登录
    method: 'post',
    api: 'admin/user/changepwd'
},
  login: { // 登录
      method: 'post',
      api: 'admin/login/'
  },
  getLoginStatus: { // 获取当前登录状态
    method: 'get',
    api: 'admin/common/loginStatus'
  },
  loginout: { // 获取当前登录状态
    method: 'get',
    api: 'admin/login/loginout'
  },
}